!function () {
  "use strict";

  customElements.get("zoom-images") || customElements.define("zoom-images", class extends HTMLElement {
    constructor() {
      super();
      this.mediaContainer = this.closest("[data-product-single-media-group]");
      this.slider = this.mediaContainer?.querySelector("[data-product-single-media-slider]");
      this.zoomWrappers = this.mediaContainer?.querySelectorAll("[data-zoom-wrapper]");
      this.a11y = window.theme.a11y;
    }

    connectedCallback() {
      if (!this.zoomWrappers.length) return;
      this.zoomWrappers.forEach((e, t) => {
        e.addEventListener("click", (o) => {
          o.preventDefault();
          if (this.slider && this.slider.classList.contains("is-moving")) return;
          this.a11y.state.trigger = e;
          this.createZoom(t);
        });
      });
    }

    createZoom(e) {
      const t = this;
      let o = [], s = 0;
      this.zoomWrappers.forEach((i) => {
        const a = i.getAttribute("href"),
              r = parseInt(i.getAttribute("data-image-width")),
              l = parseInt(i.getAttribute("data-image-height"));
        o.push({ src: a, w: r, h: l, msrc: a });
        s += 1;

        if (t.zoomWrappers.length === s) {
          let mainClass = "pswp-zoom-gallery";
          if (s === 1) mainClass = "pswp-zoom-gallery pswp-zoom-gallery--single";

          const options = {
            barsSize: { top: 60, bottom: 60 },
            history: false,
            focus: false,
            index: e,
            mainClass: mainClass,
            showHideOpacity: true,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: false,
            closeEl: true,
            closeElClasses: ["caption-close"],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 2,
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false
          };

          new window.theme.LoadPhotoswipe(o, options);

          if (o.length > 1) {
            setupCustomViewer(o, e);
          }
        }
      });
    }
  });

  function setupCustomViewer(items, startIndex) {
    let attempts = 0;
    const check = setInterval(() => {
      attempts++;
      if (attempts > 100) { clearInterval(check); return; }

      let pswpEl = null;
      document.querySelectorAll('.pswp').forEach((el) => {
        if (el.classList.contains('pswp--open') || el.classList.contains('pswp--visible')) {
          pswpEl = el;
        }
      });
      if (!pswpEl) return;

      clearInterval(check);

      // Remove old custom viewer if any
      const oldViewer = pswpEl.querySelector('.pswp__custom-viewer');
      if (oldViewer) oldViewer.remove();
      const oldThumbs = pswpEl.querySelector('.pswp__custom-thumbs');
      if (oldThumbs) oldThumbs.remove();

      // HIDE PhotoSwipe's own image container
      const scrollWrap = pswpEl.querySelector('.pswp__scroll-wrap');
      if (scrollWrap) {
        const container = scrollWrap.querySelector('.pswp__container');
        if (container) container.style.display = 'none';
      }

      // Create our own main image viewer
      const viewer = document.createElement('div');
      viewer.className = 'pswp__custom-viewer';
  viewer.style.cssText = `
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 20px;
  box-sizing: border-box;
  pointer-events: none;
`;
      const mainImg = document.createElement('img');
      mainImg.className = 'pswp__custom-main-img';
      mainImg.src = items[startIndex].src;
     mainImg.style.cssText = `
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
  transition: opacity 0.2s;
  pointer-events: auto;
`;

      viewer.appendChild(mainImg);
      pswpEl.appendChild(viewer);

      // Create thumbnails container
      const thumbsContainer = document.createElement('div');
      thumbsContainer.className = 'pswp__custom-thumbs';
     thumbsContainer.style.cssText = `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1600;
  padding: 10px 10px 16px 10px;
  text-align: center;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
//   background: rgba(0, 0, 0, 0.6);
  height: 100px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
`;
      let currentIdx = startIndex;

    function updateMainImage(idx) {
  mainImg.style.opacity = '0';
  setTimeout(() => {
    mainImg.src = items[idx].src;
    mainImg.style.opacity = '1';
  }, 150);

  thumbsContainer.querySelectorAll('a').forEach((t, i) => {
    if (i === idx) {
      t.style.opacity = '1';
      t.style.borderColor = '#fff';
      t.classList.add('is-current');
    } else {
      t.style.opacity = '0.6';
      t.style.borderColor = 'transparent';
      t.classList.remove('is-current');
    }
  });

  // Auto-scroll active thumb into view (important for mobile)
  const activeThumb = thumbsContainer.querySelector('a.is-current');
  if (activeThumb && activeThumb.scrollIntoView) {
    activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  currentIdx = idx;
}

      items.forEach((item, idx) => {
        const thumb = document.createElement('a');
        thumb.href = '#';
        thumb.setAttribute('data-index', idx);
        thumb.style.cssText = `
          display: inline-block;
          width: 60px;
          height: 60px;
          margin: 0 5px;
          border: 2px solid ${idx === startIndex ? '#fff' : 'transparent'};
          border-radius: 5px;
          background-image: url('${item.msrc || item.src}');
          background-size: cover;
          background-position: center;
          background-color: #fff;
          cursor: pointer;
          opacity: ${idx === startIndex ? 1 : 0.6};
          transition: opacity 0.2s, border-color 0.2s, transform 0.2s;
          vertical-align: middle;
        `;

        if (idx === startIndex) thumb.classList.add('is-current');

        thumb.addEventListener('mouseenter', () => {
          thumb.style.transform = 'scale(1.08)';
          if (!thumb.classList.contains('is-current')) thumb.style.opacity = '1';
        });
        thumb.addEventListener('mouseleave', () => {
          thumb.style.transform = 'scale(1)';
          if (!thumb.classList.contains('is-current')) thumb.style.opacity = '0.6';
        });

        thumb.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          const newIndex = parseInt(this.getAttribute('data-index'), 10);
          if (newIndex !== currentIdx) {
            updateMainImage(newIndex);
          }
        });

        thumbsContainer.appendChild(thumb);
      });

      pswpEl.appendChild(thumbsContainer);

      // Scroll to active thumb initially
setTimeout(() => {
  const activeThumb = thumbsContainer.querySelector('a.is-current');
  if (activeThumb && activeThumb.scrollIntoView) {
    activeThumb.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
  }
}, 100);

      // Hide PhotoSwipe's next/prev arrows since we're handling navigation ourselves
      const nextBtn = pswpEl.querySelector('.pswp__button--arrow--right');
      const prevBtn = pswpEl.querySelector('.pswp__button--arrow--left');
      if (nextBtn) nextBtn.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';

      // Cleanup when modal closes
      const observer = new MutationObserver(() => {
        if (!pswpEl.classList.contains('pswp--open') && !pswpEl.classList.contains('pswp--visible')) {
          viewer.remove();
          thumbsContainer.remove();
          if (scrollWrap) {
            const container = scrollWrap.querySelector('.pswp__container');
            if (container) container.style.display = '';
          }
          if (nextBtn) nextBtn.style.display = '';
          if (prevBtn) prevBtn.style.display = '';
          observer.disconnect();
        }
      });
      observer.observe(pswpEl, { attributes: true, attributeFilter: ['class'] });
    }, 50);
  }
}();